/**
 * @file Icon — the icon set (Standard / Dot / Social)
 * @version 0.1.0
 */

import { Standard } from './Icon.Standard';
import { Dot } from './Icon.Dot';
import { Social } from './Icon.Social';

/*
 * Icon — asset primitive (compound)
 *
 * See CATALOG. Three categories with distinct prop signatures:
 *   <Icon.Standard name="add" size="md" title="Add user" />   monochrome, theme-aware via currentColor
 *   <Icon.Dot name="close" title="Dismiss" />                 fixed 20x20 two-tone status indicator
 *   <Icon.Social name="linkedin" title="LinkedIn" />          brand mark, brand colors preserved
 *
 * Adding an icon: drop the SVG into src/assets/icons/<category>/[<size>/]<name>.svg
 * (re-run scripts/import-icons.mjs if importing from ~/Downloads). Vite's
 * import.meta.glob discovers it at build time — no registry edit needed.
 */
export const Icon = {
  Standard,
  Dot,
  Social,
};

export type { StandardIconName, StandardProps } from './Icon.Standard';
export type { DotIconName, DotProps } from './Icon.Dot';
export type { SocialIconName, SocialProps } from './Icon.Social';
